module.exports = __webpack_public_path__ + "img/coupon_bg.8aae1e4a.png";